var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97322 2.67285C8.00387 2.67285 8.83585 3.50483 8.83585 4.53548C8.83585 5.56613 8.00387 6.3981 6.97322 6.3981C5.94257 6.3981 5.1106 5.56613 5.1106 4.53548C5.1106 3.50483 5.94256 2.67285 6.97322 2.67285ZM6.97329 11.4887C5.4211 11.4887 4.04897 10.6939 3.24805 9.48944C3.26668 8.2539 5.73154 7.57715 6.97329 7.57715C8.20883 7.57715 10.6799 8.2539 10.6985 9.48944C9.89761 10.6939 8.52547 11.4887 6.97329 11.4887Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97437 0.810547C3.54714 0.810547 0.765625 3.59206 0.765625 7.01929C0.765625 10.4465 3.54714 13.228 6.97437 13.228C10.4016 13.228 13.1831 10.4465 13.1831 7.01929C13.1831 3.59206 10.4016 0.810547 6.97437 0.810547Z",
    stroke: "#444444",
    strokeWidth: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.c41093aa.svg";
export { ForwardRef as ReactComponent };